<p-table data-identifier="group-table" [value]="tableData" (onLazyLoad)="customSort($any($event))" [lazy]="true"
         sortMode="single" sortField="name" [sortOrder]="1" [totalRecords]="totalItems"
         [scrollable]="true" scrollHeight="650px" [loading]="isLoading">
  <ng-template pTemplate="header">
    <tr>
      <th [ngStyle]="{'width':'3%'}">
        <input type="checkbox"
               [checked]="isCurrentPageAllSelected()"
               (change)="toggleCurrentPage($any($event.target).checked)">
      </th>
      <th pSortableColumn="name" [ngStyle]="{'width':'52%'}" [pSortableColumn]="'name'">Group Name
          <p-sortIcon field="name"></p-sortIcon>
      </th>
      <th pSortableColumn="disabled" [ngStyle]="{'width':'15%'}" [pSortableColumn]="'disabled'">Status
        <p-sortIcon field="disabled"></p-sortIcon>
      </th>
      <th [ngStyle]="{'width':'10%'}">Total Instances
      </th>
      <th [ngStyle]="{'width':'10%'}">Active Instances
      </th>
      <th>Actions
      </th>
    </tr>
    <tr *ngIf="selectedIds.size > 0">
      <th colspan="6" class="p-2" style="background: var(--surface-0, #fff)">
        <div class="alert alert-info d-flex justify-content-between align-items-center mb-0 py-2 px-3 rounded-3">
          <div class="d-flex align-items-center gap-2">
            <span *ngIf="selectedIds.size > 0">
                <strong>{{ selectedIds.size }} {{ selectedIds.size === 1 ? 'Organization' : 'Organizations' }}</strong> Selected.
            </span>
            <button *ngIf="!allPagesSelected" class="btn btn-link fw-semibold p-0" (click)="selectAllPages()">
              {{ totalItems === 1 ? 'Select the Organization' : 'Select All ' +totalItems+ ' Organizations' }}.
            </button>
            <button *ngIf="allPagesSelected" class="btn btn-link fw-semibold p-0" (click)="clearSelection()">
                {{ totalItems === 1 ? 'Deselect the Organization' : 'Deselect All ' +totalItems+ ' Organizations' }}.
            </button>
          </div>
          <button class="btn btn-sm btn-default rounded-pill" [disabled]="isPasswordResetDisabled" (click)="onPasswordResetClick()">
            <fa-icon [icon]="faShield" class="me-1"></fa-icon> Password Reset
          </button>
        </div>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
    <tr>
      <td>
        <input type="checkbox"
               [checked]="selectedIds.has(item.id)"
               (change)="toggleRow(item, $any($event.target).checked)">
      </td>
      <td data-identifier="group-name">
        <div>{{item.name}}</div>
      </td>
      <td data-identifier="status">
        <div>{{item.disabled ? 'Inactive' : 'Active'}}</div>
      </td>
      <td data-identifier="total-instances">
        <div>{{item.organizationsCount}}</div>
      </td>
      <td data-identifier="active-instances">
        <div>{{item.activeOrganizationsCount}}</div>
      </td>
      <td data-identifier="actions">
          <a class="text-decoration-none" href="#" routerLink="/group-management/{{item.id}}/details" data-identifier="edit-link">Manage</a>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr data-identifier="no-records">
      <td [attr.colspan]="6">
          <lib-empty-state />
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer" *ngIf="!tableData">
    <tr data-identifier="table-footer">
      <td [attr.colspan]="6">
        <lib-pagination *ngIf="totalItems>0"
            #pagination
            [totalItems]="totalItems"
            [currentPage]="currentPage"
            (selectItemsPerPage)="onSelectItemsPerPage($event)"
            (changeCurrentPage)="onChangeCurrentPage($event)">
        </lib-pagination>
      </td>
    </tr>
  </ng-template>
</p-table>
